import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { FRAUD_REVIEW_STATUS_QUERY_KEY } from '../fraudReview.constants';

const postConfirmFraud = (employeeId: string) =>
  api.post(API_URL.EMPLOYEES_FRAUD_CONFIRM_BY_EMPLOYEE_ID(employeeId));

const useConfirmFraudQuery = (employeeId?: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation(() => postConfirmFraud(employeeId || ''), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRAUD_REVIEW_STATUS_QUERY_KEY, employeeId] });
      if (onSuccess) onSuccess();
    },
  });

  return {
    confirmFraud: mutateAsync,
    isPending,
  };
};

export default useConfirmFraudQuery;
